import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { General } from "../../../siteManagement/general";
import { Sheet, SheetEventType } from "../../../siteManagement/sheet";
import { Helper } from "../../core/util/helper";
import React from "react";

export default class FlagsGrid extends React.Component<any, FlagsGridState>{
    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Config.translations.newLabel,
            type: ToolBarStandardButtonType.NEW,
            enabled: true
        },
        {
            caption: Config.translations.editLabel,
            type: ToolBarStandardButtonType.EDIT,
            enabled: true
        },
        {
            caption: Config.translations.deleteLabel,
            type: ToolBarStandardButtonType.DELETE,
            enabled: true
        }
    ];

    constructor(props) {
        super(props)
        this.state = {
            gridData: []
        }
        this.initApp();
    }

    private initApp = async () => {
        await this.loadGridData();
        this.setState({});
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass>("PlanningBoardFlag/GetAllFlags");
        if (result.Code == 0)
            this.setState({ gridData: result.Data })

    }

    private renderGrid = () => {
        return (
            <div className="flex-container" style={{ height: "350px" }}>
                <Grid
                    data={this.state.gridData}
                    options={this.props.field.gridOptions}
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onButtonClick}
                    id="GeneralSettings_FlagsGrid"
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, dataItem: { Id: string }) => {
        let sheet: Sheet;
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                sheet = General.Sheet.Manager.createSheetWithUrl("PlanningBoardFlag/Edit")
                break;
            case ToolBarStandardButtonType.EDIT:
                sheet = General.Sheet.Manager.createSheetWithUrl(`PlanningBoardFlag/Edit?id=${dataItem.Id}`)
                break;
            case ToolBarStandardButtonType.DELETE:
                const isok = await DialogHelper.confirm(Config.translations.deleteMessage)
                if (isok) {
                    const result = await HTTPService.get<JsonResultClass>(`PlanningBoardFlag/Delete?id=${dataItem.Id}`);
                    if (result.Code == 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.loadGridData();
                }
                break;
        }
        if (Helper.hasValue(sheet)) {
            sheet.bind(SheetEventType.Close, this.loadGridData);
        }
    }

    render() {
        return this.renderGrid();
    }
}

interface FlagsGridState {
    gridData: {
        Id: string
    }[]
}